enum DocumentFields {
  id = 'id',
  document_id = 'document_id',
}

enum UserInfoFields {
  searchable_fields = 'searchable_fields',
  registration_date = 'registration_date',
  first_name = 'first_name',
  last_name = 'last_name',
  clinic_id = 'clinic_id',
  day_of_birth = 'day_of_birth',
  known_reproductive_disorder = 'known_reproductive_disorder',
  known_reproductive_disorders = 'known_reproductive_disorders',
  length_of_average_monthly_cycle = 'length_of_average_monthly_cycle',
  health_goal = 'health_goal',
  personal_max_lh = 'personal_max_lh',
  personal_max_pg = 'personal_max_pg',
  height_array = 'height_array',
  location = 'location',
  weight = 'weight',
  race = 'race',
  ethnicity = 'ethnicity',
  registration_last_first_date_of_period = 'registration_last_first_date_of_period',
  roles = 'roles',
  email = 'email',
  clinic_role = 'clinic_role',
  provider_id = 'provider_id',
  should_hide_not_registered_users = 'should_hide_not_registered_users',
  phone_number = 'phone_number',
  title = 'title',
  about_me = 'about_me',
  is_guidance_mode_enabled = 'is_guidance_mode_enabled',
  is_flagged_for_deactivation = 'is_flagged_for_deactivation',
  is_demo_account = 'is_demo_account',
  latest_scan_date = 'latest_scan_date',
  how_long_have_been_trying_to_conceive = 'how_long_have_been_trying_to_conceive',
  does_have_regular_period = 'does_have_regular_period',
  is_experiencing_perimenopause_symptoms = 'is_experiencing_perimenopause_symptoms',
  how_long_have_been_experiencing_perimenopause_symptoms = 'how_long_have_been_experiencing_perimenopause_symptoms',
  is_currently_undergoing_perimenopause_treatment = 'is_currently_undergoing_perimenopause_treatment',
  perimenopause_treatments = 'perimenopause_treatments',
  ever_had_period = 'ever_had_period',
  does_have_known_reproductive_disorders = 'does_have_known_reproductive_disorders',
}

enum JournalEntryFields {
  period_flow = 'period_flow',
  cervical_fluid = 'cervical_fluid',
  cervical_position = 'cervical_position',
  craving = 'craving',
  digestion = 'digestion',
  pain = 'pain',
  mental = 'mental',
  temperature = 'temperature',
  hair = 'hair',
  skin = 'skin',
  stool = 'stool',
  sex = 'sex',
  exercise = 'exercise',
  sleep = 'sleep',
  sex_drive = 'sex_drive',
  mood = 'mood',
  overall_mood = 'overall_mood',
  motivation = 'motivation',
  motivation_level = 'motivation_level',
  productivity = 'productivity',
  productivity_level = 'productivity_level',
  social = 'social',
  party = 'party',
  energy = 'energy',
  energy_level = 'energy_level',
  birth_control_pill = 'birth_control_pill',
  medication = 'medication',
  injection = 'injection',
  ailment = 'ailment',
  bleeding = 'bleeding',
  anxiety = 'anxiety',
  low_mood = 'low_mood',
  hot_flashes = 'hot_flashes',
  joint_pain = 'joint_pain',
  headache = 'headache',
  is_everything_fine = 'is_everything_fine',
  brain_fog = 'brain_fog',
  breakthrough_bleeding = 'breakthrough_bleeding',
  breast_tenderness = 'breast_tenderness',
  nausea = 'nausea',
  cramps = 'cramps',
  back_pain = 'back_pain',
  migraine = 'migraine',
  head_hair = 'head_hair',
  body_hair_growth = 'body_hair_growth',
  skin_changes = 'skin_changes',
  acne = 'acne',
  acne_legacy = 'acne_legacy',
  cravings = 'cravings',
  bloating = 'bloating',
  painful_urination = 'painful_urination',
  urination_frequency = 'urination_frequency',
  incontinence = 'incontinence',
  sexual_activity = 'sexual_activity',
  painful_sex = 'painful_sex',
  exercise_intensity = 'exercise_intensity',
  exercise_perceived_effort = 'exercise_perceived_effort',
  hours_of_sleep = 'hours_of_sleep',
  sleep_quality = 'sleep_quality',
  dreams = 'dreams',
  dream_type = 'dream_type',
  focus = 'focus',
  memory_problems = 'memory_problems',
  mood_stability = 'mood_stability',
  emotional_stability = 'emotional_stability',
  stress = 'stress',
  vitamins_and_supplements = 'vitamins_and_supplements',
  drinking = 'drinking',
  cannabis = 'cannabis',
  hangover = 'hangover',
  heart_palpitations_or_racing_heart = 'heart_palpitations_or_racing_heart',
  weight_gain = 'weight_gain',
  dizziness = 'dizziness',
  night_sweats = 'night_sweats',
  hair_loss_or_thinning = 'hair_loss_or_thinning',
  skin_dryness_and_itching = 'skin_dryness_and_itching',
  face_sagging_and_wrinkles = 'face_sagging_and_wrinkles',
  vaginal_dryness = 'vaginal_dryness',
  uti_symptoms = 'uti_symptoms',
}

enum ClinicInfoFields {
  id = 'id',
  name = 'name',
  address1 = 'address1',
  address2 = 'address2',
  city = 'city',
  zipCode = 'zipCode',
  state = 'state',
  phone = 'phone1',
  isPatientSharingOn = 'is_patient_sharing_on',
  isAutomaticPatientToClinicLocationConnectionEnabled = 'is_automatic_patient_to_clinic_location_connection_enabled',
  clinicId = 'clinic_id',
  description = 'description',
  imagePath = 'image_path',
}

enum ClinicLocationFields {
  id = 'id',
  name = 'name',
  email = 'email',
  address1 = 'address1',
  address2 = 'address2',
  city = 'city',
  zipCode = 'zipCode',
  state = 'state',
  phone1 = 'phone1',
  phone2 = 'phone2',
  clinic_location_id = 'clinic_location_id',
  services_description = 'services_description',
  is_providing_remote_care = 'is_providing_remote_care',
}

enum LotFields {
  created_at = 'created_at',
  document_id = 'document_id',
  name = 'name',
  scan_with_flash = 'scan_with_flash',
  status = 'status',
  date_of_manufacture = 'date_of_manufacture',
  date_of_expiry = 'date_of_expiry',
  comment = 'comment',
  lot_data_document_url = 'lot_data_document_url',
  no_of_manufactured_cartridges = 'no_of_manufactured_cartridges',
  ax_array = 'ax_array',
  lh_array = 'lh_array',
  pg_array = 'pg_array',
  e3g_array = 'e3g_array',
  type = 'type',
  e3g_config_result = 'e3g_config_result',
  lh_config_result = 'lh_config_result',
  pg_config_result = 'pg_config_result',
  x = 'x',
  raw_x = 'raw_x',
  efficiency = 'efficiency',
  min_concentration = 'minConcentrationUsedForModelFit',
  max_concentration = 'maxConcentrationUsedForModelFit',
  min_signal = 'minSignalUsedForModelFit',
  max_signal = 'maxSignalUsedForModelFit',
  is_concentration_increased_with_signal = 'doesConcentrationIncreaseAsSignalIncreases',
  minMeasurableConcentration = 'minMeasurableConcentration',
  maxMeasurableConcentration = 'maxMeasurableConcentration',
  lh_unit = 'lh_unit',
  pg_unit = 'pg_unit',
  lr_e3g_unit = 'lr_e3g_unit',
  lr_e3g_model_fit_parameters = 'lr_e3g_model_fit_parameters',
  lh_model_fit_parameters = 'lh_model_fit_parameters',
  pg_model_fit_parameters = 'pg_model_fit_parameters',
  is_scanning_blocked_for_android = 'is_scanning_blocked_for_android',
  is_scanning_blocked_for_ios = 'is_scanning_blocked_for_ios',
  scanning_blocked_android_error_message = 'scanning_blocked_android_error_message',
  scanning_blocked_ios_error_message = 'scanning_blocked_ios_error_message',
  qr_code_width_in_millimeter = 'qr_code_width_in_millimeter',
  sample_area_width_in_millimeter = 'sample_area_width_in_millimeter',
  sample_area_height_in_millimeter = 'sample_area_height_in_millimeter',
  permitted_to_scan_by_oova_app = 'permitted_to_scan_by_oova_app',
  internal_id = 'internal_id',
  partner = 'partner',
  process_tracker_url = 'process_tracker_url',
  status_notes = 'status_notes',
}

enum ScanFields {
  lh = 'lh',
  pg = 'pg',
  e3g = 'e3g',
  lr_e3g = 'lr_e3g',
  lot_id = 'lot_id',
  userId = 'user_id',
  is_demo_scan = 'is_demo_scan',
  day = 'day',
}

enum ScanMetaFields {
  os = 'os',
  device_model = 'device_model',
  app_version = 'app_version',
}

enum ScanToolkitOutputFields {
  toolkit_version = 'toolkit_version',
  warning = 'warning',
  warnings = 'warnings',
  error = 'error',
  warning_code = 'warning_code',
  error_code = 'error_code',
}

enum OrderFields {
  internal_id = 'internal_id',
  user_email = 'user_email',
  status = 'status',
  fulfillment_status = 'fulfillment_status',
  payment_status = 'payment_status',
}

enum ArticleFields {
  id = 'id',
  topic = 'topic',
  section = 'section',
  timing = 'timing',
  title = 'title',
  word_count = 'word_count',
  days_in_post_ovulation = 'days_in_post_ovulation',
  cta = 'cta',
  color = 'color',
  url = 'url',
  created_at = 'created_at',
  updated_at = 'updated_at',
}

enum ConfigurationSettingsFields {
  user = 'user',
  updated_at = 'updated_at',
  created_at = 'created_at',
  is_automated_order_processing_enabled = 'is_automated_order_processing_enabled',
  shiphero_public_api_access_token = 'shiphero_public_api_access_token',
  shiphero_public_api_access_token_timestamp = 'shiphero_public_api_access_token_timestamp',
  shiphero_public_api_access_token_expiration = 'shiphero_public_api_access_token_expiration',
  default_order_dropshipping_partner = 'default_order_dropshipping_partner',
  provider_default_stripe_link = 'provider_default_stripe_link',
  default_shiphero_operator_hold = 'default_shiphero_operator_hold',
  is_automated_order_processing_to_opsengine_enabled = 'is_automated_order_processing_to_opsengine_enabled',
  skip_po_box_checking = 'skip_po_box_checking',
  default_scan_processing_toolkit_version = 'default_scan_processing_toolkit_version',
  is_opsengine_routed_to_warehance = 'is_opsengine_routed_to_warehance',
}

enum ScanSequenceFields {
  is_clinical_monitoring_recommended = 'is_clinical_monitoring_recommended',
  description = 'description',
  order = 'order',
  is_enabled = 'is_enabled',
  scanning_plan_type = 'scanning_plan_type',
  health_goal = 'health_goal',
}

enum GroupedEntitlementFields {
  user_role = 'user_role',
  clinic_role = 'clinic_role',
  resource = 'resource',
  supervise = 'supervise',
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete',
}

enum NotificationContentFields {
  title = 'title',
  category = 'category',
  created_at = 'created_at',
  updated_at = 'updated_at',
  short_description = 'short_description',
  full_description = 'full_description',
  disclaimer = 'disclaimer',
  is_published = 'is_published',
  app_version = 'app_version',
}

enum NotificationFields {
  category = 'category',
  created_at = 'created_at',
  published_at = 'published_at',
  is_approvement_pending = 'is_approvement_pending',
}

enum UserScanningPlanFields {
  created_at = 'created_at',
}

enum NpsSurveyResponseFields {
  submitted_at = 'submitted_at',
  user_name = 'user_name',
  nps_score = 'nps_score',
  platform = 'platform',
  submitted_at_from = 'submitted_at_from',
  submitted_at_to = 'submitted_at_to',
}

enum NpsSurveyResponseMetaFields {
  app_version = 'app_version',
  device_model = 'device_model',
  os = 'os',
}

export {
  DocumentFields,
  UserInfoFields,
  JournalEntryFields,
  ClinicInfoFields,
  LotFields,
  ClinicLocationFields,
  ScanFields,
  ScanMetaFields,
  ScanToolkitOutputFields,
  OrderFields,
  ArticleFields,
  ConfigurationSettingsFields,
  ScanSequenceFields,
  GroupedEntitlementFields,
  NotificationContentFields,
  NotificationFields,
  UserScanningPlanFields,
  NpsSurveyResponseFields,
  NpsSurveyResponseMetaFields,
};
